import React, { useContext, useEffect, useState } from "react";
import SocketContext from "../../../../../context/SocketContext";
import moment from "moment";

export default function Time(props) {
  const socket = useContext(SocketContext);

  const symbol_id = props.symbol_id;

  const [time, setTime] = useState(0);

  useEffect(() => {
    socket.emit("giverate", symbol_id);
    socket.on("trade" + symbol_id, trade);
    return () => {
      socket.off("trade" + symbol_id, trade);
    };
  }, []);

  const trade = (data) => {
    if (data != null) {
      setTime(data.Timestamp);
    }
  };

  return <div className="menuBuyPrice small">{time}</div>;
}
